import confetti from 'canvas-confetti'

const defaults = {
  spread: 360,
  ticks: 200,
  gravity: 0,
  decay: 0.92,
  startVelocity: 30,
}

// Function to cover the entire screen with confetti
export function shootFullScreen() {
  const count = 200 // Number of confetti pieces
  const angle = 60
  const spread = 70
  const colors = ['#EF2054', '#E92944', '#C92323', '#F78430', '#6941c6']

  // Create confetti bursts from both sides
  confetti({
    ...defaults,
    particleCount: count / 2,
    angle: angle,
    spread: spread,
    origin: { x: 0, y: 0.65 }, // Left side
    colors: colors,
  })

  confetti({
    ...defaults,
    particleCount: count / 2,
    angle: 120,
    spread: spread,
    origin: { x: 1, y: 0.65 }, // Right side
    colors: colors,
  })

  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: count / 2,
      angle: 90,
      spread: 90,
      origin: { x: 0.5, y: 1.2 }, // Bottom center
      colors: colors,
    })
  }, 500)
}

// Standard click-based confetti animation
export function shoot(x, y) {
  confetti({
    ...defaults,
    particleCount: 60,
    scalar: 1.2,
    shapes: ['square'],
    colors: ['#EF2054', '#E92944', '#C92323', '#F78430', '#6941c6'],
    origin: { x: x / window.innerWidth, y: y / window.innerHeight },
  })

  confetti({
    ...defaults,
    particleCount: 20,
    scalar: 2,
    shapes: ['text'],
    shapeOptions: {
      text: { value: ['🦄', '🌈'] },
    },
    origin: { x: x / window.innerWidth, y: y / window.innerHeight },
  })
}

export function withClick(Component) {
  return function WrappedComponent(props) {
    const handleClick = (event) => {
      const { clientX, clientY } = event
      shoot(clientX, clientY)
      setTimeout(() => shoot(clientX, clientY), 100)
      setTimeout(() => shoot(clientX, clientY), 200)
    }

    return (
      <Component {...props} onClick={handleClick}>
        {props.children}
      </Component>
    )
  }
}

export function withHover(Component) {
  return function WrappedComponent(props) {
    const handleHover = (event) => {
      const { clientX, clientY } = event
      shoot(clientX, clientY)
      setTimeout(() => shoot(clientX, clientY), 100)
      setTimeout(() => shoot(clientX, clientY), 200)
    }

    return (
      <Component {...props} onMouseEnter={handleHover}>
        {props.children}
      </Component>
    )
  }
}
